<dx-form
    *ngIf="workOrderInfo"
    width="100%"
    height="100%"
    class="job-info-container"
    labelLocation="top"
    [colCount]="1"
    [scrollingEnabled]="true"
>
    <dxi-item itemType="group" caption="Job Status" [colCount]="2">
        <dxi-item [isRequired]="true">
            <dxo-label text="Status"></dxo-label>
            <div *dxTemplate>
                <dx-select-box
                    displayExpr="displayText"
                    valueExpr="key"
                    [searchEnabled]="true"
                    [dataSource]="workOrderEditor.statusList"
                    [(value)]="workOrderInfo.statusCode"
                ></dx-select-box>
            </div>
        </dxi-item>
        <dxi-item [isRequired]="true">
            <dxo-label text="Responsible"></dxo-label>
            <div *dxTemplate>
                <!-- 
                    NOTE: Design Change
                    Responsible will get enabled after community selection. 
                    Agreed with Sandeep on 19th Sept 2022
                -->
                <app-multi-column-selector
                    [name]="'Responsible'"
                    [disabled]="!workOrderInfo.communityId && workOrderInfo.communityId === 0"
                    [gridSource]="workOrderEditor.responsibleList"
                    [boxValue]="responsibleBoxValue"
                    [valueExpr]="'userId'"
                    [displayExpr]="'name'"
                    [columnDef]="responsibleColumns"
                    [dropDownButtonTemplate]="'dropDownButton'"
                    [dropDownOptions]="{ width: 'auto' }"
                    [showClearButton]="true"
                    [placeholder]="'Select Responsible...'"
                    (gridSelectionEvent)="onResponsibleSelection($event)"
                ></app-multi-column-selector>
            </div>
        </dxi-item>
        <dxi-item [isRequired]="true">
            <dxo-label text="Priority"></dxo-label>
            <div *dxTemplate>
                <dx-select-box
                    displayExpr="displayText"
                    valueExpr="key"
                    [searchEnabled]="true"
                    [dataSource]="workOrderEditor.priorityList"
                    [(value)]="workOrderInfo.priorityCode"
                ></dx-select-box>
            </div>
        </dxi-item>
        <dxi-item>
            <dxo-label text="Due Date"></dxo-label>
            <div *dxTemplate>
                <dx-date-box
                    type="date"
                    [openOnFieldClick]="true"
                    [showClearButton]="true"
                    [(value)]="workOrderInfo.dueDate"
                ></dx-date-box>
            </div>
        </dxi-item>
    </dxi-item>

    <dxi-item itemType="group" caption="Job Information" [colCount]="2">
        <dxi-item [isRequired]="true">
            <!-- 
                    NOTE: Design Change
                    Job Type will be a required field now in v2.
                    Agreed with Sandeep on 26th Sept 2022 
                -->
            <dxo-label text="Job Type"></dxo-label>
            <div *dxTemplate>
                <dx-select-box
                    displayExpr="displayText"
                    valueExpr="key"
                    [searchEnabled]="true"
                    [dataSource]="workOrderEditor.jobTypeList"
                    [(value)]="workOrderInfo.jobTypeCode"
                ></dx-select-box>
            </div>
        </dxi-item>
        <dxi-item>
            <dxo-label text="Authorization Amount"></dxo-label>
            <div *dxTemplate>
                <dx-number-box
                    [showClearButton]="true"
                    [showSpinButtons]="false"
                    [min]="0"
                    [format]="currencyFormat"
                    [(value)]="workOrderInfo.authorizationAmount"
                ></dx-number-box>
            </div>
        </dxi-item>
        <dxi-item [isRequired]="true">
            <dxo-label text="Reference Type"></dxo-label>
            <div *dxTemplate>
                <!-- 
                    NOTE: Design Change
                    Reference Type will get enabled after community selection.
                    Agreed with Sandeep on 19th Sept 2022 
                -->
                <dx-select-box
                    displayExpr="displayText"
                    valueExpr="key"
                    [disabled]="!workOrderInfo.communityId && workOrderInfo.communityId === 0"
                    [searchEnabled]="true"
                    [dataSource]="referenceTypes"
                    [(value)]="workOrderInfo.referenceTypeCode"
                    (onValueChanged)="onReferenceTypeCodeChanged()"
                ></dx-select-box>
            </div>
        </dxi-item>
        <dxi-item [isRequired]="workOrderInfo?.referenceTypeCode !== 'O'">
            <dxo-label text="Reference"></dxo-label>
            <div *dxTemplate>
                <!-- 
                    NOTE: Design Change
                    Reference will get enabled after community selection. 
                    Agreed with Sandeep on 19th Sept 2022
                -->
                <dx-text-box [readOnly]="true" [(value)]="referenceName">
                    <ng-container *ngIf="workOrderInfo?.referenceTypeCode !== 'O'">
                        <dxi-button
                            name="search"
                            location="after"
                            [options]="{
                                type: 'default',
                                hint: 'Select Reference',
                                icon: 'more',
                                disabled: !workOrderInfo.communityId && workOrderInfo.communityId === 0,
                                onClick: onReferenceClick 
                            }"
                        ></dxi-button>
                    </ng-container>
                    <dxi-button name="clear-search" location="after" [options]="clearButton"></dxi-button>
                </dx-text-box>
            </div>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <dxo-label text="Location and Contact Special Instructions"></dxo-label>
            <div *dxTemplate>
                <dx-text-area [height]="80" [(value)]="workOrderInfo.specialInstructions"></dx-text-area>
            </div>
        </dxi-item>
    </dxi-item>
</dx-form>

<app-work-order-editor-reference-selector
    *ngIf="showReferenceSelector"
    [communityId]="workOrderInfo.communityId"
    [referenceTypeCode]="workOrderInfo.referenceTypeCode"
    (onSelect)="onReferenceSelect($event)"
    (onClose)="onReferenceSelectorClose()"
></app-work-order-editor-reference-selector>

<cc-message-box #workOrderJobInfoMessgeBox></cc-message-box>
